const DocumentIcon2 = ({ className = "w-[17px] h-[21px]" }) => {
  return (<>
    <svg className={className} viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.30078 20.5C1.75078 20.5 1.27995 20.3042 0.888281 19.9125C0.496615 19.5208 0.300781 19.05 0.300781 18.5V2.5C0.300781 1.95 0.496615 1.47917 0.888281 1.0875C1.27995 0.695833 1.75078 0.5 2.30078 0.5H10.3008L16.3008 6.5V18.5C16.3008 19.05 16.1049 19.5208 15.7133 19.9125C15.3216 20.3042 14.8508 20.5 14.3008 20.5H2.30078ZM9.30078 7.5V2.5H2.30078V18.5H14.3008V7.5H9.30078Z" fill="currentColor" />
    </svg>

  </>)
}
export default DocumentIcon2;